import { render, staticRenderFns } from "./CustomSwiper.vue?vue&type=template&id=6da4b8ee&scoped=true&"
import script from "./CustomSwiper.vue?vue&type=script&lang=ts&"
export * from "./CustomSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSwiper.vue?vue&type=style&index=0&id=6da4b8ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da4b8ee",
  null
  
)

export default component.exports